import { Theme } from '@/theme';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  html,
  body {
    font:
      ${Theme.font.style.normal} ${Theme.font.weight.regular} 16px / 1.4
      ${Theme.font.family.speedee}, 'Helvetica', 'Arial',
      system-ui, -apple-system, sans-serif, monospace;

    background-color: ${Theme.color.white};
    -webkit-overflow-scrolling: touch;

    color: ${Theme.color.text};
    -webkit-user-select: none;
    overscroll-behavior: none;

    scroll-behavior: smooth;
    letter-spacing: 0.15px;
    overflow: hidden auto;

    touch-action: none;
    user-select: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: ${Theme.font.weight.bold};
    line-height: ${Theme.rems(28.6)};
    font-size: ${Theme.rems(26)};
    color: ${Theme.color.text};

    letter-spacing: 0;
    padding: 0px;
    margin: 0px;
  }

  a {
    font-weight: ${Theme.font.weight.bold};
    font-size: ${Theme.rems(15)};
    color: ${Theme.color.white};
    text-decoration: underline;

    letter-spacing: 0;
    padding: 0px;
    margin: 0px;

    &:hover,
    &:focus,
    &:active,
    &:visited {
      outline: none;
    }
  }

  b,
  strong {
    font-style: normal;
    letter-spacing: 0.15px;
    font-size: ${Theme.rems(15)};
    font-weight: ${Theme.font.weight.bold};
  }

  p,
  span {
    font-weight: ${Theme.font.weight.regular};
    font-size: ${Theme.rems(15)};

    color: ${Theme.color.text};
    letter-spacing: 0.15px;

    padding: 0px;
    margin: 0px;
  }

  button {
    font-size: ${Theme.rems(16)};
    color: ${Theme.color.text};

    cursor: pointer;
    outline: none;
    border: none;

    padding: 0px;
    margin: 0px;
  }

  img,
  svg,
  figure {
    vertical-align: top;
    max-width: 100%;
  }

  .grecaptcha-badge {
    pointer-events: none;
    visibility: hidden;
  }
`;
